function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  .label {\n    width: 40%;\n    display: flex;\n    justify-content: flex-start;\n  }\n  .value {\n    width: 40%;\n    display: flex;\n    justify-content: flex-end;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
import Text from '../../atoms/Text';
var RowContainer = styled.div(_templateObject());

var ListItem = function ListItem(_ref) {
  var _data$label, _data$label2, _data$value, _data$value2;

  var data = _ref.data,
      variant = _ref.variant,
      containerClass = _ref.containerClass;
  return /*#__PURE__*/React.createElement(RowContainer, {
    className: containerClass || ''
  }, /*#__PURE__*/React.createElement("div", {
    className: "label"
  }, ((_data$label = data === null || data === void 0 ? void 0 : data.label) !== null && _data$label !== void 0 ? _data$label : false) && /*#__PURE__*/React.createElement(Text, {
    text: (_data$label2 = data === null || data === void 0 ? void 0 : data.label) !== null && _data$label2 !== void 0 ? _data$label2 : '',
    size: variant && {
      primary: 'iconLabel',
      secondary: 'helperText'
    }[variant],
    color: variant && {
      primary: 'default',
      secondary: 'bodyTextLight'
    }[variant],
    variant: "light",
    name: "label"
  })), /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, ((_data$value = data === null || data === void 0 ? void 0 : data.value) !== null && _data$value !== void 0 ? _data$value : false) && /*#__PURE__*/React.createElement(Text, {
    text: (_data$value2 = data === null || data === void 0 ? void 0 : data.value) !== null && _data$value2 !== void 0 ? _data$value2 : '',
    size: variant && {
      primary: 'iconLabel',
      secondary: 'helperText'
    }[variant],
    color: variant && {
      primary: 'default',
      secondary: 'bodyTextLight'
    }[variant],
    variant: "light",
    name: "value"
  })));
};

ListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  containerClass: PropTypes.string,
  variant: PropTypes.string,
  data: PropTypes.object.isRequired
} : {};
ListItem.defaultProps = {
  variant: 'primary',
  containerClass: '',
  theme: defaultTheme
};
export default ListItem;